module.exports = __webpack_public_path__ + "img/jzaijian.46cebc78.gif";